import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import SettingsMenu from './settingsMenu'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { TitletypeContext } from '../../../../contexts/settings/titlettype.context'
import PaginatorCRM from '../../../../components/prime-pagination/CRMPaginator'
import { useSelector } from 'react-redux'
import AccessDenied from '../../../authentication/accessDenied'

const TitleTypeSettings = () => {
  const { info, isSuperAdmin } = useSelector((state: any) => state?.role)
  const roles: any = info || {}
  const isSAdmin: any = isSuperAdmin || false
  const title_type = isSAdmin || roles?.title_type

  const [show, setShow] = useState<boolean>(false)
  const { listData, titleTypeList, setsearchTerm, childRef } =
    useContext(TitletypeContext)
  const [detail, setDetail] = useState('')

  const data = listData.map((item: any) => {
    return {
      id: item?.id,
      titleType: item?.title_type_name,
      description: item?.type_description,
    }
  })

  const handleShow = (value: any, item: any) => {
    if (value == 'edit-titletype' || value == 'delete-titletype') {
      setDetail(item)
    }
    setShow(value)
  }
  const handleClose = () => {
    setShow(false)
  }

  const titleTypes = (data: any, index: any) => {
    return (
      <>
        <div className='customer-name'>
          <h5>{data?.titleType}</h5>
          <h6>{data?.description} </h6>
        </div>
      </>
    )
  }
  const titleTypeAction = (data: any, index: any) => {
    return (
      <>
        <ul className='action-table'>
          <li>
            <Link to='#' onClick={() => handleShow('edit-titletype', data)}>
              <i className='ti ti-edit'></i>
            </Link>
          </li>
          <li>
            <Link to='#' onClick={() => handleShow('delete-titletype', data)}>
              <i className='ti ti-trash'></i>
            </Link>
          </li>
        </ul>
      </>
    )
  }
  return (
    <>
      <div className='row'>
        <SettingsMenu />
        <div className='col-lg-9'>
          {title_type ? (
            <div className='card'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='table-title'>
                      <h4>Title Type</h4>
                    </div>
                    <div className='table-header'>
                      <div className='row'>
                        <div className='col-lg-3 col-md-6 col-12'>
                          <button
                            className='btn btn-primary w-100'
                            onClick={() => handleShow('add-titletype', '')}
                          >
                            <i className='ti ti-plus me-1'></i>New Title Type
                          </button>
                        </div>
                        <div className='col-lg-7 col-md-6 col-12'>
                          <div className='table-search'>
                            <div className='search-icon'>
                              <i className='ti ti-search'></i>
                            </div>
                            <input
                              type='text'
                              placeholder='Search'
                              onChange={(e) => setsearchTerm(e.target.value)}
                            />
                            <div className='adjustments-icon'>
                              <i className='ti ti-adjustments-horizontal'></i>
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-2 col-md-6 col-12'>
                          <div className='sorting-table'>
                            <ul>
                              <li className='w-100'>
                                <select
                                  className='select'
                                  value={`${childRef?.current?.pg_state.rows}`}
                                  onChange={(e) =>
                                    childRef?.current?.handleLimitChange(e)
                                  }
                                >
                                  <option value={5}>5</option>
                                  <option value={10}>10</option>
                                  <option value={15}>15</option>
                                  <option value={20}>20</option>
                                </select>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='table-responsive'>
                      <div className='datatable'>
                        <DataTable
                          className=' table dataTable'
                          value={data}
                          tableStyle={{ minWidth: '50rem' }}
                        >
                          <Column
                            field='titleType'
                            header='Title Type'
                            body={titleTypes}
                            sortable
                            sortField='title_type_name'
                          ></Column>

                          <Column
                            header='ACTIONS'
                            body={titleTypeAction}
                          ></Column>
                        </DataTable>
                        <PaginatorCRM
                          listfunction={titleTypeList}
                          ref={childRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AccessDenied />
          )}
        </div>
      </div>

      <AddTitleType show={show} handleClose={handleClose} detail={detail} />
      <DeleteTitleType
        show={show}
        handleClose={handleClose}
        modalName='This title will be deleted. Do you confirm?'
        detail={detail}
      />
    </>
  )
}
export default TitleTypeSettings
